export function TableInteractionNote() {
  return (
    <p className="fs-14 fst-italic mt-4 mb-0">
      On some screens, tables may be scrollable or draggable.
    </p>
  );
}

export default TableInteractionNote;